const helpsiteSearchMapper = require('./helpsite-search-mapper');
const DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID = window.config.DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID;
const POPULAR_ARTICLE_CONFIG = window.config.POPULAR_ARTICLE_IDS
    ? window.config.POPULAR_ARTICLE_IDS.split(',').map(item => {
        const [id, ...titleParts] = item.split(':');
        return {
            id: id.trim(),
            title: titleParts.join(':').trim() // Handles titles with colons
        };
    })
    : [];

module.exports = function HelpCenterDirective(helpCenterService, $sce, BwsBotService, atm) {
    return {
        restrict: 'E',
        template: require('./help-center-template.html'),
        scope: true,
        controller: ['$scope', '$state', '$stateParams', '$timeout', function (scope, $state, $stateParams, $timeout) {
            // Initialize category-section-map when directive loads
            helpCenterService.getCategorySectionMap()
                .then(function (categorySectionMap) {
                    scope.categorySectionMap = categorySectionMap;
                })
                .catch(function (error) {
                });

            // Default initialization function
            function defaultInitialization() {
                scope.searchTerm = "";
                scope.currentPageNumber = 1;
                scope.searchResult = {};
                scope.searchedArticles = [];
                scope.popularArticles = [];
                scope.totalNumberOfArticles = 0;
                scope.totalNumberOfPages = 0;
                scope.shouldShowLandingPageTemplate = true;
                scope.shouldShowQuickAnswerSection = true;
                scope.shouldShowPopularArticlesSection = true;
                scope.shouldShowArticle = false;
                scope.selectedArticleId = 0;
                scope.latestArticle = null;
                scope.showFAQSection = false; // Initialize as false
                scope.articleSummaries = {};
                scope.expandedArticleId = null;
                scope.expandedArticles = {}; // Initialize the map

                // Fetch latest article for service callout
                helpCenterService.getLatestServiceCalloutArticle()
                    .then(function (article) {
                        scope.latestArticle = article;
                    });
                populatePopularArticles(); // Load all articles (static + dynamic)

            }

            // Initialize defaults
            defaultInitialization();

            // Fetch BWS articles for FAQ section
            scope.bwsArticles = [];
            helpCenterService.getBwsArticles()
                .then(function (articles) {
                    if (articles) {
                        scope.bwsArticles = articles;
                        // Only show FAQ if we're on the landing page
                        if (scope.shouldShowLandingPageTemplate) {
                            scope.showFAQSection = true;
                        }
                    } else {
                        scope.showFAQSection = false;
                    }
                })
                .catch(function (error) {
                    scope.showFAQSection = false;
                });



            scope.toggleArticle = function (articleId) {
                articleId = articleId.toString();

                // Toggle the expanded state
                scope.expandedArticles[articleId] = !scope.expandedArticles[articleId];

                // Only load if not already loaded
                if (!scope.articleSummaries[articleId]) {
                    scope.articleSummaries[articleId] = {
                        loading: true,
                        summary: 'Loading...',
                        fullUrl: '#'
                    };

                    helpCenterService.getArticleSummary(articleId)
                        .then(function (response) {
                            scope.articleSummaries[articleId] = {
                                summary: response.summary || 'No content available',
                                fullUrl: response.fullUrl || '#',
                                loaded: true,
                                error: false
                            };
                        })
                        .catch(function (error) {
                            scope.articleSummaries[articleId] = {
                                summary: 'Failed to load content',
                                fullUrl: '#',
                                loaded: false,
                                error: true
                            };
                        });
                }
            };


            // Search function
            scope.getSearchResult = function (searchText) {
                scope.searchText = searchText;
                scope.searchTerm = searchText;
                $state.go('shop.helpcenter.search', { searchtext: searchText });

                // Track search event
                atm.push({
                    linkName: `web:help-centre page:searchTerm:${searchText}`,
                    searchTerm: `${searchText}`
                }, helpsiteSearchMapper);
            };

            // Handle enter key press
            scope.checkEnterKey = function (event, searchText) {
                if (event.keyCode === 13) {
                    scope.getSearchResult(searchText);
                }
            };

            // Show article details
            scope.showArticle = function (articleId) {
                hideAllTemplates();
                scope.selectedArticleId = articleId;
                scope.shouldShowArticle = true;
            };

            scope.goToArticle = function (popularArticleId) {
                $state.go('shop.helpcenter.articles', { articleId: popularArticleId });
            };

            scope.categoryFilter = function (category) {
                return category.id != DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID;
            };

            // Template visibility controls
            scope.showSearchTemplate = function () {
                hideAllTemplates();
                scope.shouldShowSearchResultTemplate = true;
            };

            scope.showLandingPageTemplate = function () {
                hideAllTemplates();
                scope.shouldShowLandingPageTemplate = true;
                scope.shouldShowQuickAnswerSection = true;
                scope.shouldShowPopularArticlesSection = true;
                // Only show FAQ if we have articles
                scope.showFAQSection = scope.bwsArticles && scope.bwsArticles.length > 0;

                // Refresh latest article when returning to landing page
                helpCenterService.getLatestServiceCalloutArticle()
                    .then(function (article) {
                        scope.latestArticle = article;
                    });

                scope.$broadcast('clearSearchInput');
            };

            function hideAllTemplates() {
                scope.shouldShowSearchResultTemplate = false;
                scope.shouldShowLandingPageTemplate = false;
                scope.shouldShowSectionArticles = false;
                scope.shouldShowArticle = false;
                scope.shouldShowQuickAnswerSection = false;
                scope.shouldShowPopularArticlesSection = false;
                scope.showFAQSection = false;
            }

            function populatePopularArticles() {
                // 1. Set static articles from config (always first)
                scope.popularArticles = angular.copy(POPULAR_ARTICLE_CONFIG);

                // 2. Fetch dynamic articles (if category exists)
                if (DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID) {
                    helpCenterService.getSectionsByCategoryId(DYNAMIC_POPULAR_ARTICLE_CATEGORY_ID)
                        .then(sections => Promise.all(
                            sections.map(s => helpCenterService.getArticlesBySectionId(s.id))
                        ))
                        .then(articlesArrays => {
                            const dynamicArticles = articlesArrays.flat();
                            const uniqueDynamicArticles = dynamicArticles.filter(dynamicArticle =>
                                !scope.popularArticles.some(staticArticle => staticArticle.id === dynamicArticle.id)
                            );

                            // Append unique dynamic articles AFTER static ones
                            scope.popularArticles = [
                                ...scope.popularArticles, // Static articles
                                ...uniqueDynamicArticles  // Unique dynamic articles
                            ];
                        })
                        .catch(err => {
                            // Keep static articles even if dynamic load fails
                        });
                }
            }
            // Category and section handling
            scope.categories = [];
            scope.sections = [];
            scope.articles = [];
            scope.shouldShowSectionArticles = false;
            scope.selectedCategoryId = null;

            // Fetch categories
            helpCenterService.getCategories()
                .then(function (categories) {
                    scope.categories = categories || [];
                    scope.$evalAsync();
                })
                .catch(function (error) {
                    scope.categories = [];
                });

            // Show sections for a category
            scope.showSectionsArticles = function (categoryId) {
                hideAllTemplates();
                scope.shouldShowSectionArticles = true;
                scope.selectedCategoryId = categoryId;
                scope.shouldShowQuickAnswerSection = true;

                // Use the pre-loaded categorySectionMap if available
                if (scope.categorySectionMap) {
                    const categoryData = scope.categorySectionMap.find(c => c.categoryId === categoryId);
                    if (categoryData) {
                        scope.sections = categoryData.sectionData;
                        return;
                    }
                }

                // Fallback to API call if map not available
                helpCenterService.getSectionsByCategoryId(categoryId)
                    .then(function (sections) {
                        scope.sections = sections;
                    });
            };

            // Quick answer section controls
            scope.showQuickAnswerAndPopularArticlesSection = function () {
                scope.shouldShowPopularArticlesSection = true;
                scope.shouldShowQuickAnswerSection = true;
            };

            scope.hideQuickAnswerAndPopularArticlesSection = function (categoryId) {
                scope.shouldShowPopularArticlesSection = false;
                scope.shouldShowQuickAnswerSection = false;
            };

            // Chat bot integration
            scope.openChatBot = function () {
                BwsBotService.chatWithBot();
            };

            // State handling
            switch ($state.current.name) {
                case 'shop.helpcenter.search':
                    scope.getSearchResult($stateParams.searchtext);
                    break;
                default:
                    scope.showLandingPageTemplate();
            }

            scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
                switch (toState.name) {
                    case 'shop.helpcenter.sections':
                        scope.showSectionsArticles(toParams.categoryId);
                        scope.showFAQSection = false;
                        break;
                    case 'shop.helpcenter.articles':
                        scope.showArticle(toParams.articleId);
                        scope.showFAQSection = false;
                        break;
                    case 'shop.helpcenter.search':
                        if (!scope.shouldShowSearchResultTemplate) {
                            scope.showSearchTemplate();
                        }
                        scope.showFAQSection = false;
                        break;
                    default:
                        defaultInitialization();
                        populatePopularArticles(); // Updated function name
                        scope.showLandingPageTemplate();
                        // Show FAQ only if we have articles
                        scope.showFAQSection = scope.bwsArticles && scope.bwsArticles.length > 0;
                }
            });

            // Use the category-section-map to get category/section info when showing articles
            scope.getCategorySectionInfo = function (sectionId) {
                if (!scope.categorySectionMap) return null;

                for (const category of scope.categorySectionMap) {
                    const section = category.sectionData.find(s => s.sectionId === sectionId);
                    if (section) {
                        return {
                            categoryId: category.categoryId,
                            categoryName: section.categoryName,
                            sectionName: section.sectionName
                        };
                    }
                }
                return null;
            };
        }],
        link: function (scope, element) {
            scope.$on('clearSearchInput', function () {
                scope.searchText = ''; // Clear the model
            });
        }

    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/help-center-directive.js
 **/